<template>
    <v-card class="py-2 modal-search-purpose-of-uses">
        <div class="px-2" ref="modalScrollArea">
            <div class="modal-content">
                <div class="overflow-y-auto" style="margin-bottom: 50px;">
                    <div class="modal-header">
                        <v-card-title>
                            <div class="modal_header_text">
                                <span>備品・サービスから探す</span>
                            </div>
                        </v-card-title>
                        <button @click="closeModal" type="button" class="btn-close_popup">
                            <i class="fa-solid fa-xmark" style="color: #2892d7"></i>
                        </button>
                    </div>
                    <div class="card-text">
                        <div class="modal-header" v-if="selectedSummaryNew.length != 0">
                            <h3>適用中の備品・サービス &nbsp;<a href="javascript:void(0)" @click="clearSelection">クリア</a></h3>
                            <div class="header_text_block">
                                <span v-for="(item, index) in selectedSummaryNew" :key="index">
                                    {{ item.type === 'all' ? item.name + 'すべて' : item.name }}
                                </span>
                            </div>
                        </div>
                        <div class="accordion-container">
                            <div v-for="(section, index) in accordionData" :key="index" class="accordion-section">
                                <div class="accordion-header" :class="{ open: openSections[index] }">
                                    <div class="accordian_Text" @click="toggleAccordion(index)">
                                        <h3>{{ section.name }}</h3>
                                        <span v-html="openSections[index]
                                            ? '<i class=\'fa-solid fa-angle-down\' ></i>'
                                            : '<i class=\'fa-solid fa-angle-up\'></i>'
                                            "></span>
                                    </div>
                                    <button class="min-w-[65px]" @click="selectAll(section)"
                                        :class="{ active: !isAllSelected(section) }">すべて</button>
                                </div>
                                <div v-if="openSections[index]" class="accordion-content">
                                    <div class="accordian_contant_button">
                                        <button @click="selectAll(section)"
                                            :class="{ active: !isAllSelected(section) }">すべて</button>
                                    </div>
                                    <div class="accordianCustomeCheckBox_Detail">
                                        <label v-for="(item, i) in section.children" :key="i" class="custom-checkbox">
                                            <input type="checkbox" v-model="selectedItems" :value="item" />
                                            <span class="checkmark"></span>
                                            {{ item.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal_bottom_contant">
                    <a href="javascript:void(0)" @click="clearSelection">クリア</a>
                    <button @click="applyConditions">条件を適用する</button>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script setup>
/* eslint-disable */
import { ref, defineEmits, onMounted, computed } from "vue";
import { string } from "yup";

// Emit event for closing modal
const emit = defineEmits(["handleEquipmentAndServicesModal"]);
const closeModal = () => {
    emit("handleEquipmentAndServicesModal");
};

const props = defineProps({
    dataEquipmentOption: {
        type: Object,
        default: () => ({
            option_parent_ids: [],
            option_ids: []
        })
    },
    allListEquipmentOption: {
        type: Array,
        required: true,
    },
});

const accordionData = ref([]);

//  State to track which accordion section is open
const openSections = ref(
    accordionData.value.map(() => true) //  All sections open by default
);

const toggleAccordion = (index) => {
    openSections.value[index] = !openSections.value[index]; // Toggle specific section
};

// Select All Items in Section
const selectedItems = ref([]);
const selectedItemsParent = ref([]);

const isAllSelected = (section) => {
    if (!section.children || section.children.length == 0) {
        return selectedItemsParent.value.some(item => item == section.id);
    }
    return section.children.every(child =>
        selectedItems.value.includes(child)
    );
};
const wasAllSelectedMap = ref({});
const selectAll = (section) => {
    if (!section.children || section.children.length == 0) {
        if(selectedItemsParent.value.includes(section.id)) {
            selectedItemsParent.value = selectedItemsParent.value.filter(item => item !== section.id)
        } else {
            selectedItemsParent.value.push(section.id)
        }
        return;
    }
    const allSelected = isAllSelected(section);
    wasAllSelectedMap.value[section.id] = !allSelected;
    if (allSelected) {
        // Unselect all
        selectedItems.value = selectedItems.value.filter(
            item => !section.children.includes(item)
        );
    } else {
        // Select all
        section.children.forEach(child => {
            if (!selectedItems.value.includes(child)) {
                selectedItems.value.push(child);
            }
        });
    }

};

onMounted(async () => {
    const response = props.allListEquipmentOption;

    accordionData.value = response.map((item) => {
        const children = (item.referral_options || []).map((opt) => ({
            ...opt,
            parent: item.id,
        }));
        return {
            ...item,
            children,
        };
    });

    openSections.value = accordionData.value.map(() => true);
    
    const parentIds = Array.isArray(props.dataEquipmentOption.option_parent_ids)
        ? props.dataEquipmentOption.option_parent_ids.map(id => Number(id))
        : typeof props.dataEquipmentOption.option_parent_ids === 'string'
            ? props.dataEquipmentOption.option_parent_ids.split(',').map(id => Number(id))
            : [];

    const optionIds = Array.isArray(props.dataEquipmentOption.option_ids)
        ? props.dataEquipmentOption.option_ids.map(id => Number(id))
        : typeof props.dataEquipmentOption.option_ids === 'string'
            ? props.dataEquipmentOption.option_ids.split(',').map(id => Number(id))
            : [];


    const selected = [];

    accordionData.value.forEach((section) => {
        // Select parent without children
        if ((!section.children || section.children.length === 0) && parentIds.includes(section.id)) {
            selected.push({ id: section.id, name: section.name });
        }

        // Select all children if parent is selected
        if (section.children && parentIds.includes(section.id)) {
            section.children.forEach((child) => {
                selected.push(child);
            });
        }

        // Select individual children if specified
        section.children?.forEach((child) => {
            if (optionIds.includes(child.id) && !selected.some((s) => s.id === child.id)) {
                selected.push(child);
            }
        });
    });

    selectedItems.value = selected;
    
    selectedSummaryNew.value = selectedSummary.value;

});

const selectedSummary = computed(() => {
    const selectedIds = selectedItems.value.map(item => item.id);
    const result = [];

    accordionData.value.forEach(section => {
        const selectedChildren = section.children.filter(child =>
            selectedIds.includes(child.id)
        );
        if (selectedChildren.length > 0 && selectedChildren.length == section.children.length) {
            // All children selected → show parent with "すべて"
            result.push({ type: 'all', name: section.name });
        } else {
            // Some children selected → show each name
            selectedChildren.forEach(child => {
                result.push({ type: 'child', name: child.name });
            });
        }
    });

    return result;
});

const clearSelection = () => {
    selectedItems.value = [];
    const selectedParentCategories = [];
    const selectedChildOption = [];
    emit('applyEquipmentAndServicesConditions', { parents: selectedParentCategories, children: selectedChildOption });
    closeModal();
};
const modalScrollArea = ref(null);
const selectedSummaryNew = ref([]);

const applyConditions = () => {
  const selectedIds = selectedItems.value.map(item => item.id);

  const selectedParentCategories = []; // { id, name }
  const selectedChildOption = [];      // { id, name }

  accordionData.value.forEach(section => {
    const hasChildren = section.children && section.children.length > 0;

    if (!hasChildren) {
      // Parent without children, selected directly
      if (selectedIds.includes(section.id)) {
        selectedParentCategories.push({
          id: section.id,
          name: section.name,
        });
      }
      return;
    }

    const selectedChildren = section.children.filter(child =>
      selectedIds.includes(child.id)
    );

    const allChildrenSelected = selectedChildren.length === section.children.length;

    if (allChildrenSelected) {
      // Push parent
      selectedParentCategories.push({
        id: section.id,
        name: section.name,
      });
    }

    // Always push selected children regardless of whether all are selected
    selectedChildren.forEach(child => {
      selectedChildOption.push({
        id: child.id,
        name: child.name,
      });
    });
  });

  emit('applyEquipmentAndServicesConditions', {
    parents: selectedParentCategories,
    children: selectedChildOption,
    selectedSummary: selectedSummary.value
  });

  selectedSummaryNew.value = selectedSummary.value;
  closeModal();
};
</script>
<style scoped lang="scss">
@import "./ModalEquipmentAndServices.scss";
</style>
